import { useDraftStore } from '@/lib/draftStore';
import { FormField } from '@/components/ui/FormField';
import { TextInput } from '@/components/ui/TextInput';
import { TextArea } from '@/components/ui/TextArea';
import { Select } from '@/components/ui/Select';
import type { ItemCondition } from '@/types/domain';

const CONDITION_OPTIONS: { value: ItemCondition; label: string }[] = [
  { value: 'new', label: 'Идеальное (10/10)' },
  { value: 'good', label: 'Хорошее' },
  { value: 'no_box', label: 'Без коробки' },
  { value: 'damaged_figure', label: 'С дефектом фигурки' },
  { value: 'damaged', label: 'С дефектом коробки' },
];

export const Step2Basic = () => {
  const draft = useDraftStore((s) => s.draft);
  const update = useDraftStore((s) => s.update);

  return (
    <>
      <FormField label="Название" required hint="Кратко и понятно — модель, бренд, серия">
        <TextInput
          value={draft.title}
          onChange={(e) => update({ title: e.target.value })}
          placeholder="Например: Funko Pop Evangelion Asuka"
          maxLength={120}
        />
      </FormField>

      <FormField
        label="Описание"
        required
        hint="Состояние, комплектация, особенности, история"
      >
        <TextArea
          value={draft.description}
          onChange={(e) => update({ description: e.target.value })}
          placeholder="Расскажи покупателю всё важное о лоте"
          rows={5}
          maxLength={2000}
        />
      </FormField>

      <FormField label="Состояние" required>
        <Select
          value={draft.condition}
          onChange={(v) => update({ condition: v })}
          options={CONDITION_OPTIONS}
        />
      </FormField>

      <FormField label="Город" required hint="Где забирать / Откуда отправлять">
        <TextInput
          value={draft.city}
          onChange={(e) => update({ city: e.target.value })}
          placeholder="Москва"
        />
      </FormField>
    </>
  );
};

export const validateStep2 = (draft: {
  title: string;
  description: string;
  city: string;
}): string | null => {
  if (draft.title.trim().length < 3) return 'Слишком короткое название';
  if (draft.description.trim().length < 10) return 'Слишком короткое описание';
  if (draft.city.trim().length < 2) return 'Укажи город';
  return null;
};